import queryString from 'query-string';
import * as constants from './Constants';
import * as api from './Api';
import * as utils from './Utils';


let pendingFunctions = [];

function getToken() {
  const ovData = window.OnVoardData;
  const platform = utils.getEcommercePlatform();
  const el = document.querySelector(".ov-app-web-tracking");
  if (!el) return;

  let token = el.getAttribute('data-token');
  if (!token && platform === 'shopline') {
    if (ovData && ovData.config) {
      token = ovData.config['web_tracking_token'];
    }
  }

  if (token && !el.getAttribute('data-token')) {
    el.setAttribute("data-token", token);
  }

  return token;
}

function track(activity, recordData) {
  // contact ID must be available else push this to pending
  const contactId = utils.getCookie(constants.COOKIE_CONTACT_ID);
  if (!contactId) {
    pendingFunctions.push({
      functionName: 'track',
      parameters: [activity, recordData]
    });

    return;
  }

  const token = getToken();
  if (!token) {
    console.error("Missing web tracking token");
    return;
  }

  const payload = {};
  payload['contact'] = contactId;
  payload['activity'] = activity;
  payload['record_data'] = recordData;

  const url = utils.buildUrl(`track/${token}`);
  navigator.sendBeacon(url, JSON.stringify(payload));
}

function identify(contactData) {
  if (!contactData) return;

  const contactId = utils.getCookie(constants.COOKIE_CONTACT_ID);
  if (!contactId && !contactData.email) return;
  contactData['id'] = contactId;

  const successCallback = (response) => {
    utils.setCookie(constants.COOKIE_CONTACT_ID, response.contact_id);

    pendingFunctions.forEach((row) => {
      process(['web_tracking', row.functionName, ...row.parameters]);
    })

    pendingFunctions = [];
  };

  const errorCallback = (error) => {
    console.error(error);
  };

  const token = getToken();
  if (!token) {
    console.error("Missing web tracking token");
    return;
  }

  const payload = {};
  payload['contact'] = contactData;
  payload['token'] = token;
  api.postIdentify(successCallback, errorCallback,
    token, JSON.stringify(payload));
}


function getWebTrackingHandler() {
  const webTracking = {};
  webTracking.identify = function(contactData) {
    identify(contactData);
  };

  webTracking.track = function(activity, recordData) {
    track(activity, recordData);
  };

  return webTracking;
}


function process(args) {
  const webTracking = getWebTrackingHandler();
  var params = [].slice.call(args);
  var ns = params.shift();
  var method = params.shift();

  // web_tracking namespace
  if (ns === "web_tracking") {
    if (webTracking[method]) {
     webTracking[method].apply(webTracking, params);
    } else {
      console.log(`web_tracking does not have a ${method} method`);
    }
  }
};

// use contact ID to identify if it's passed via URL
function presetDataFromUrl() {
  if (!utils.isBrowser()) return;

  const queue = window.OnVoardQueue.webTracking || [];
  const qs = queryString.parse(window.location.search);
  const contactId = utils.getCookie(constants.COOKIE_CONTACT_ID);

  // only add if there's no existing identify function and if
  // contact ID is not found in cookie
  const identifyCallExists = queue.some((q) => {
    var params = [].slice.call(q);
    var ns = params.shift();
    var method = params.shift();
    return ns === "web_tracking" && method === "identify";
  })

  if (!identifyCallExists && !contactId && qs['ov_contact']) {
    let contactId = decodeURIComponent(qs['ov_contact']);
    utils.setCookie(constants.COOKIE_CONTACT_ID, contactId);
  }

  // Capture the email/SMS click token on the LANDING page. This has to happen here, at init on
  // an ordinary storefront page, because the click and the purchase are never the same
  // pageview - by the time conversion-tracking reads the cookie on the thank-you page, the
  // ?ov_click= that carried it is long gone from the URL.
  //
  // Unlike ov_contact above there is no "already known" guard: a visitor clicking a second,
  // newer email is starting a NEW touch, and the freshest click is the one that brought them
  // here. utils.getClickId() applies the same precedence when it reads.
  utils.getClickId();
}

export function processTracking() {
  presetDataFromUrl();

  // process queued function calls
  const queue = window.OnVoardQueue.webTracking || [];
  for (var i in queue) {
    process(queue[i]);
  }

  // setup api endpoint after everything is ready
  window.OnVoardApi.webTracking = function(args) {
    process(args);
  };
}


